var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import ReactDOM from 'react-dom';
import { observer } from 'mobx-react';
import { Actor_ } from '../../../components/actor/Actor_';
import { Aspect_ } from '../../../components/actor/Aspect_';
let SortableItemPortalAware = class SortableItemPortalAware extends React.PureComponent {
    render() {
        const { provided, snapshot, sortableItem } = this.props;
        const usePortal = false && snapshot.isDragging;
        const child = (React.createElement(Aspect_, { aspect: sortableItem.ownAspect.wrapper, templateComponent: React.createElement("div", { ref: provided.innerRef, ...provided.draggableProps, ...provided.dragHandleProps }) },
            React.createElement(Actor_, { actor: sortableItem })));
        return child;
        return ReactDOM.createPortal(child, document.getElementById('dndportal'));
    }
};
SortableItemPortalAware = __decorate([
    observer
], SortableItemPortalAware);
export { SortableItemPortalAware };
